class WishlistUtils {
  static get wishlistId() {
    const cookies = decodeURIComponent(document.cookie).split(";");
    const cookieString = "wishlist_id=";

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();

      if (cookie.indexOf(cookieString) === 0) {
        return cookie.substring(cookieString.length);
      }
    }

    return null;
  }

  static async retrieveWishlist() {
    if (this.wishlist) return this.wishlist;

    const response = await fetch(
         window.Shopify.routes.root + `/a/wishlist?type=api&wishlistid=${WishlistUtils.wishlistId}&version=1`,
      {
        method: "GET",
        cache: "no-store",
      }
    );

    const data = await response.json();
    const items = data.items;

    localStorage.setItem("wishlist", JSON.stringify(items));

    return items;
  }

  static get wishlist() {
    const wishlistObj = localStorage.getItem("wishlist");
    return wishlistObj && JSON.parse(wishlistObj);
  }

  static removeFromSmartWishlist(product) {
    RemoveFromSmartWishlist(product.id, product.variant_id);
    let wishlist = this.wishlist;
    if (!wishlist) return;

    wishlist = wishlist.filter(
      (item) => item.id !== product.id || item.variant_id !== product.variant_id
    );
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
  }

  static addToSmartWishlist(product) {
    AddToSmartWishlist(product.id, product.variant_id);
    let wishlist = WishlistUtils.wishlist;

    if (!wishlist) return;

    wishlist.push(product);
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
  }

  static isInWishlist(product) {
    let wishlist = WishlistUtils.wishlist;
    if (!wishlist) return false;

    return wishlist.find(
      (item) => item.id === product.id && item.variant_id === product.variant_id
    );
  }
}

class CustomWishlist extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.loadWishlist();
    this.onWishlistChange = subscribe(PUB_SUB_EVENTS.wishlistChange, () => {
      this.loadWishlist();
    });
  }

  disconnectedCallback() {
    this.onWishlistChange && this.onWishlistChange();
  }

  loadWishlist() {
    WishlistUtils.retrieveWishlist();
    const items = WishlistUtils.wishlist;
     this.renderItems(items.reverse());
  }

  async renderItems(items) {
    const rootUrl = window.routes.root_url || "";
    let fetchPromises = [];

    if (!items?.length) {
      this.querySelector('[data-empty-wishlist]').classList.remove("tw-hidden");
    }

    items.forEach(item => {
      const batchPromise = fetch(
        `${location.origin + rootUrl}/products/${item.handle}?view=wishlist&variant=${item.variant_id}`
      ).then((response) => response.text());
      fetchPromises.push(batchPromise);
    });

    let result = "";
    const responses = await Promise.all(fetchPromises);
    for (let responseText of responses) {
      try {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        result += html.querySelector("[data-wishlist-product]").innerHTML;
      } catch (error) {
        console.error("Error parsing response:", error);
      }
    }

    this.querySelector(".collection-grid").innerHTML = result;
  }
}
customElements.define("custom-wishlist", CustomWishlist);

class WishlistButton extends HTMLElement {
  constructor() {
    super();
  }

  get product() {
    return this.dataset.product;
  }

  get variant() {
    return this.dataset.variant;
  }

  get handle() {
    return this.dataset.handle;
  }

  get item() {
    return {
      id: this.product,
      variant_id: this.variant,
      handle: this.handle,
    };
  }

  get isInWishlist() {
    return WishlistUtils.isInWishlist(this.item);
  }

  connectedCallback() {
    this.setStyle();
    this.addEventListener("click", (event) => {
      this.isInWishlist
        ? WishlistUtils.removeFromSmartWishlist(this.item)
        : WishlistUtils.addToSmartWishlist(this.item);

      this.setStyle();
      publish(PUB_SUB_EVENTS.wishlistChange);
    });
  }

  setStyle() {
    const svg = this.querySelector(".svg-wrapper");

    if (!svg) return;

    let [add, remove] = this.isInWishlist
      ? ["full", "empty"]
      : ["empty", "full"];
    svg.classList.add(add);
    svg.classList.remove(remove);
  }
}

customElements.define("wishlist-button", WishlistButton);

class WishlistIcon extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.loadIcon();
    this.onWishlistChange = subscribe(PUB_SUB_EVENTS.wishlistChange, () => {
      this.loadIcon();
    });
  }

  disconnectedCallback() {
    this.onWishlistChange && this.onWishlistChange();
  }

  async loadIcon() {
    const wishlist = await WishlistUtils.retrieveWishlist();
    const size = wishlist.length || 0;

    this.querySelector("[data-bubble]")?.classList.toggle(
      "!tw-hidden",
      size === 0
    );

    if (this.querySelector("[data-count]")) {
      this.querySelector("[data-count]").innerHTML = size;
    }

    const svg = this.querySelector(".svg-wrapper");
    if (!svg) return;

    let [add, remove] = size > 0
      ? ["full", "empty"]
      : ["empty", "full"];
    svg.classList.add(add);
    svg.classList.remove(remove);
  }
}

customElements.define("wishlist-icon", WishlistIcon);
